module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jriq4"))).then(() => parcelRequire('5erN3'));